module.exports = __webpack_public_path__ + "img/page.c25b3fa6.png";